var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import Icon from '../icon';
import iconFolder from './img/media.svg';
var FolderItem = /** @class */ (function (_super) {
    __extends(FolderItem, _super);
    function FolderItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleExpand = function (expandedItem) {
            if (_this.props.onExpand && !_this.props.disabled) {
                var expanded = _this.props.expandedIds.includes(expandedItem.id);
                _this.props.onExpand(expandedItem.id, !expanded);
            }
        };
        _this.handleSelect = function (selectedItem) {
            if (_this.props.onSelect && !_this.props.disabled) {
                _this.props.onSelect(selectedItem.id);
            }
        };
        _this.renderExpandedIcon = function (item) {
            if (item.children) {
                var expanded = _this.props.expandedIds.includes(item.id);
                var iconName = expanded ? 'minus-fill' : 'plus-fill';
                return React.createElement(Icon, { name: iconName, className: "expand-icon", onClick: function () { return _this.handleExpand(item); } });
            }
            return null;
        };
        _this.renderChildren = function (item) {
            var expanded = _this.props.expandedIds.includes(item.id);
            if (item.children && expanded) {
                return (React.createElement("ul", { className: "tree-sub-list" }, item.children.map(function (child) { return (React.createElement(FolderItem, { key: child.id, item: child, selectedId: _this.props.selectedId, disabled: child.disabled, expandedIds: _this.props.expandedIds, onExpand: _this.props.onExpand, onSelect: _this.props.onSelect })); })));
            }
            return null;
        };
        return _this;
    }
    FolderItem.prototype.render = function () {
        var _this = this;
        var item = this.props.item;
        var classNames = ['tree-item'];
        if (item.children) {
            classNames.push('has-child');
        }
        if (this.props.selectedId === item.id) {
            classNames.push('selected');
        }
        if (this.props.disabled) {
            classNames.push('disabled');
        }
        return (React.createElement("li", { className: classNames.join(' ') },
            React.createElement("span", { className: "tree-item-expand" }, this.renderExpandedIcon(item)),
            React.createElement("span", { className: "tree-item-content", onClick: function () { return _this.handleSelect(item); } },
                React.createElement("img", { src: iconFolder, className: "folder-icon" }),
                item.name),
            this.renderChildren(item)));
    };
    return FolderItem;
}(React.Component));
export default FolderItem;
//# sourceMappingURL=folder-item.js.map